// src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  //   useEffect(() => {
  //   const body = document.body;
  //   const jsScroll = document.getElementById("root");

  //   if (!jsScroll) return;

  //   const speed = 0.05;
  //   let offset = 0;
  //   let raf;

  //   // Set body height to 100%
  //   body.style.height = "100vh";

  //   function smoothScroll() {
  //     offset += (window.pageYOffset - offset) * speed;
  //     const scroll = `translateY(-${offset}px) translateZ(0)`;
  //     jsScroll.style.transform = scroll;
  //     raf = requestAnimationFrame(smoothScroll);
  //   }

  //   smoothScroll();

  //   return () => {
  //     cancelAnimationFrame(raf);
  //     jsScroll.style.transform = ""; // reset transform
  //     body.style.height = ""; // reset height
  //   };
  // }, []);
  useEffect(() => {
    // Scrolls to top whenever the pathname changes
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
